/* Split out of DrawUtils so the map reducer can call it without importing
   DrawUtils, which pulls in mapbox-gl-draw and its snap plugin (~240 kB) —
   that dependency reached the entry chunk through actions/map.js. This
   function only drives an already-constructed draw instance. */
const syncDrawState = (action) => {
  const { drawRef, value } = action;
  const { mode, snap, modeOptions, multipleLines } = value;

  if (!drawRef || !drawRef.current) return;

  const draw = drawRef.current;

  if (mode) {
    if (draw.getMode() !== mode || modeOptions) {
      draw.changeMode(mode, modeOptions);
    }
  }

  if (snap !== undefined && draw.options.snap !== snap) {
    draw.options.snap = snap;
  }

  if (multipleLines !== undefined) {
    draw.options.multipleLines = multipleLines;
  }
};

export default syncDrawState;
